<template>
  <div>
    <v-container grid-list-md text-xs-center pa-0>
      <v-progress-linear
        :active="loading"
        height="3"
        class="my-0"
        :indeterminate="true"
      ></v-progress-linear>
      <v-layout row py-0>
        <v-spacer></v-spacer>
        <v-btn icon :disabled="loading" @click="_setResults()">
          <v-icon class="text--secondary">refresh</v-icon>
        </v-btn>
      </v-layout>
      <v-layout
        row
        wrap
        py-0
        mb-4
        v-for="(phase, index1) in phases"
        :key="phase._id"
      >
        <v-flex xs12 px-2 py-0>
          <v-card>
            <v-card-text class="px-0 py-1">
              <v-flex text-xs-center xs12>
                <h2 class="headline">{{ phase.name }}</h2>
              </v-flex>
              <v-flex text-xs-center xs12>
                <template v-for="(hour, i) of phase.hours">
                  <v-chip pill outlined :key="hour + i"> {{ hour }}</v-chip>
                </template>
              </v-flex>
              <v-flex text-xs-center xs12>
                <v-btn
                  v-if="
                    can('edit', 'tournament', tournament) && phase.randomMatches
                  "
                  @click="createRandomMatches(tournament._id, phase._id)"
                  class="ma-0"
                  color="primary"
                  small
                >
                  <span v-if="loading && phaseId === phase._id">
                    <v-progress-circular
                      :size="20"
                      :width="3"
                      color="#FFFFFF"
                      indeterminate
                    ></v-progress-circular>
                  </span>
                  <span v-else>{{ $t('randomMatches') }}</span>
                </v-btn>
              </v-flex>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex
          px-2
          py-3
          xs12
          sm6
          md4
          lg3
          v-for="group in phase.groups"
          :key="group._id"
        >
          <v-card color="grey lighten-5">
            <v-card-title primary-title class="px-2 pb-0 pt-3">
              <div>
                <h3 class="title font-weight-regular mb-0">{{ group.name }}</h3>
              </div>
            </v-card-title>
            <v-card-text class="body-1 px-2 pb-0">
              <template v-for="(match, index) in group.matches">
                <v-layout
                  row
                  wrap
                  pt-0
                  py-1
                  align-content-center
                  :key="match._id"
                >
                  <v-flex xs2 align-self-center class="font-weight-bold">{{
                    match.time
                  }}</v-flex>
                  <template v-if="tournament.type == 'teams'">
                    <v-flex xs3 pl-3 align-self-center>{{
                      match.homeTeam
                    }}</v-flex>
                    <v-flex xs2 px-0 mx-0 align-self-center>
                      <template v-if="phase.showResults && match.canOpen">
                        <span class="body-1 font-weight-bold">{{
                          match.homeTeamResult
                        }}</span>
                      </template>
                      <template v-else>
                        <i
                          v-if="match.homeTeamResult === true"
                          class="success--text icon material-icons subheading"
                          >check_circle</i
                        >
                        <i
                          v-else-if="match.homeTeamResult === false"
                          class="error--text icon material-icons subheading"
                          >cancel</i
                        >
                        <span v-else>-</span>
                      </template>
                      <!-- </v-flex>
                      <v-flex xs1 align-self-center>-->
                      -
                      <template v-if="phase.showResults && match.canOpen">
                        <span class="body-1 font-weight-bold">{{
                          match.visitorTeamResult
                        }}</span>
                      </template>
                      <template v-else>
                        <i
                          v-if="match.visitorTeamResult === true"
                          class="success--text icon material-icons subheading"
                          >check_circle</i
                        >
                        <i
                          v-else-if="match.visitorTeamResult === false"
                          class="error--text icon material-icons subheading"
                          >cancel</i
                        >
                        <span v-else>-</span>
                      </template>
                    </v-flex>
                    <v-flex xs3 align-self-center>{{
                      match.visitorTeam
                    }}</v-flex>
                    <v-flex xs2 align-self-center>
                      <v-progress-circular
                        v-if="loadingMatch == match._id"
                        indeterminate
                        color="primary"
                        :size="20"
                        :width="3"
                      ></v-progress-circular>
                      <template v-else>
                        <v-btn
                          v-if="match.canOpen"
                          @click="
                            view({ matchId: match._id, actId: match.actId })
                          "
                          flat
                          icon
                          small
                          color="primary"
                          style="width:0px"
                          class="my-0"
                        >
                          <v-icon class="icon material-icons subheading"
                            >visibility</v-icon
                          >
                        </v-btn>
                        <v-btn
                          v-if="
                            can('edit', 'tournament', tournament) ||
                              can('edit', 'match', match)
                          "
                          @click="setGroup(phase, group, match, 'update')"
                          flat
                          small
                          icon
                          color="success"
                          style="width:0px"
                          class="my-0"
                        >
                          <v-icon class="icon material-icons subheading"
                            >create</v-icon
                          >
                        </v-btn>
                        <v-btn
                          v-if="
                            can('edit', 'tournament', tournament) ||
                              can('delete', 'match', match)
                          "
                          @click="setGroup(phase, group, match, 'delete')"
                          flat
                          small
                          icon
                          color="error"
                          style="width:0px"
                          class="my-0"
                        >
                          <v-icon class="icon material-icons subheading"
                            >delete</v-icon
                          >
                        </v-btn>
                      </template>
                    </v-flex>
                  </template>
                  <template v-else>
                    <v-flex xs6 align-self-center>{{ match.userName }}</v-flex>
                    <v-flex xs2 align-self-center>
                      <template v-if="phase.showResults && match.canOpen">
                        <span class="body-1 font-weight-bold">{{
                          match.userResult
                        }}</span>
                      </template>
                    </v-flex>
                    <v-flex xs2 align-self-center>
                      <v-progress-circular
                        v-if="loadingMatch == match._id"
                        indeterminate
                        color="primary"
                        :size="20"
                        :width="3"
                      ></v-progress-circular>
                      <template v-else>
                        <v-btn
                          v-if="match.canOpen"
                          @click="
                            view({ matchId: match._id, actId: match.actId })
                          "
                          flat
                          small
                          icon
                          color="primary"
                          style="width:0px"
                          class="my-0"
                        >
                          <v-icon class="icon material-icons subheading"
                            >visibility</v-icon
                          >
                        </v-btn>
                        <v-btn
                          v-if="
                            can('edit', 'tournament', tournament) ||
                              can('edit', 'match', match)
                          "
                          @click="setGroup(phase, group, match, 'update')"
                          flat
                          icon
                          small
                          color="success"
                          style="width:0px"
                          class="my-0"
                        >
                          <v-icon class="icon material-icons subheading"
                            >create</v-icon
                          >
                        </v-btn>
                        <v-btn
                          v-if="
                            can('edit', 'tournament', tournament) ||
                              can('delete', 'match', match)
                          "
                          @click="setGroup(phase, group, match, 'delete')"
                          flat
                          icon
                          small
                          color="error"
                          style="width:0px"
                          class="my-0"
                        >
                          <v-icon class="icon material-icons subheading"
                            >delete</v-icon
                          >
                        </v-btn>
                      </template>
                    </v-flex>
                  </template>
                </v-layout>
                <v-divider
                  v-if="index + 1 < group.matches.length"
                  :key="`divider-${index}`"
                ></v-divider>
              </template>
            </v-card-text>

            <v-card-actions class="pt-0">
              <v-spacer></v-spacer>

              <v-btn
                v-if="can('edit', 'tournament', tournament)"
                @click="setGroup(phase, group)"
                flat
                icon
                color="primary"
              >
                <v-icon class="icon material-icons">add</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-divider
          v-if="index1 + 1 < phases.length"
          class="mt-3"
          :key="`divider-phases-${index1}`"
        ></v-divider>
      </v-layout>
      <v-layout v-if="boardAds" row wrap mt-5>
        <v-divider></v-divider>
        <v-flex xs12 text-xs-center align-self-center>
          <img
            v-for="(boardAd, index) of boardAds"
            :key="index + 132"
            :src="imageUrl + boardAd.img"
            :width="boardAd.width"
            :height="boardAd.height"
            style="max-width: 100%"
            alt
          />
        </v-flex>
      </v-layout>
    </v-container>

    <form-match
      @close="closeModal()"
      :Edit="edit"
      :modal="modal"
      :external-action="action"
      :external-match="matchSend"
      external-type="tournament"
      :phase="phase"
      :external-location="group.pitch"
      @created="match => updateGroup(match)"
    />
    <match-view @close="closeModal()" :modal="viewModal" />

    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">{{ $t('confirmation') }}</v-card-title>
        <v-card-text>{{ $t('confirmDeleteMatchFromGroup') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color flat="flat" @click="dialog = false">{{
            $t('cancel')
          }}</v-btn>

          <v-btn
            color="red"
            flat="flat"
            :loading="this.match && loadingMatch == this.match._id"
            @click="remove()"
            >{{ $t('delete') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { timeFormat } from '@/helpers/dateHelper'
import formMatch from '@/components/apps/matches/formManager'
import MatchView from '@/components/apps/matches/MatchView'

export default {
  name: 'tabTabla',
  components: {
    formMatch,
    MatchView
  },
  props: {
    tournament: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      modal: false,
      viewModal: false,
      dialog: false,
      loading: false,
      loadingMatch: '',
      action: 'create',
      edit: true,
      phase: {},
      group: {},
      match: {},
      phaseId: '',
      imageUrl: process.env.VUE_APP_IMAGE_URL
    }
  },
  computed: {
    ...mapState({
      tournamentId: state => state.tournaments.idSelected,
      listPitches: state => state.pitches.listPortionPitches,
      listMatches: state => state.matches.list,
      ranking: state => state.matches.ranking,
      results: state => state.matches.results,
      matchSend: state => state.matches.matchSelected,
      listAds: state => state.advertising.list,
      ad: state => state.advertising.Selected,
      authUser: state => state.authentication.user
    }),

    phases() {
      if (!this.tournament || !this.tournament.phases) return []
      let phases = this.tournament.phases.map(phase => {
        return {
          _id: phase._id,
          name: this.getName(phase.name),
          order: phase.order,
          showResults: phase.showResults,
          randomMatches: phase.randomMatches,
          groups: this.formatPhaseGroups(phase),
          hours: phase.hours
        }
      })
      return phases
    },
    boardAds() {
      if (this.tournamentId) {
        let filteredAds = this.listAds.filter(
          ad =>
            ad.active &&
            ad.tournamentId == this.tournamentId &&
            ad.location == 'boardTournament'
        )
        return filteredAds.length ? filteredAds : null
      } else return null
    }
  },
  methods: {
    ...mapActions({
      getOne: 'matches/setOne',
      getOneTournament: 'tournaments/setOne',
      setOneActByScore: 'acts/setOneByScore',
      clearOneActs: 'acts/setClearOne',
      clearOne: 'matches/setClearOne',
      setUpdateGroup: 'groups/setUpdate',
      setUpdateMatch: 'matches/setUpdate',
      setUpdateMatchX: 'matches/setUpdateX',
      setNewMatchX: 'matches/setNewX',
      getOneTournaments: 'tournaments/setOne',
      setRandomMatches: 'tournaments/setRandomMatches',
      setResults: 'matches/setResults'
    }),
    _setResults() {
      this.loading = true
      this.getOneTournament(this.tournamentId)
      this.setResults(this.tournamentId).finally(_ => (this.loading = false))
    },
    parseTime(value) {
      return timeFormat(value, false)
    },
    formatPhaseGroups(phase) {
      let groups = phase.groups.map(group => {
        return {
          _id: group._id,
          name: this.getName(group.name),
          order: group.order,
          pitch: group.pitch,
          matches: this.formatGroupMatches(group, phase.showResults)
        }
      })
      return groups
    },
    formatGroupMatches(group, showResults) {
      let matches = this.tournament.matches.filter(match =>
        group.matches.includes(match._id)
      )

      matches.forEach(match => {
        if (this.tournament.type == 'teams') {
          match.homeTeamResult = this.getObjectResult(
            match,
            match.homeTeamId,
            showResults
          )
          match.homeTeam = this.formatParticipant(match.homeTeamId, 'homeTeam')
          match.visitorTeamResult = this.getObjectResult(
            match,
            match.visitorTeamId,
            showResults
          )
          match.visitorTeam = this.formatParticipant(
            match.visitorTeamId,
            'visitorTeam'
          )
        } else {
          match.userResult = this.getObjectResult(
            match,
            match.user,
            showResults
          )
          match.userName = this.formatParticipant(match.user, 'user')
        }
        match.canOpen = this.canOpen(match)
      })

      matches = matches.sort((a, b) => {
        const [hourA, minutesA] = a.time.split(':')
        const [hourB, minutesB] = b.time.split(':')
        const hourDiff = hourA - hourB
        if (hourDiff != 0) return hourDiff
        return minutesA - minutesB
      })
      return matches
    },
    canOpen(match) {
      // let isParticipant = false
      // if (this.tournament.type == 'teams') {
      //   isParticipant = this.tournament.teams.some(team =>
      //     this.hasRole('participant', team.teamId)
      //   )
      // } else {
      //   isParticipant = this.tournament.users.some(
      //     user => user.userId == this.authUser._id
      //   )
      // }
      // if (isParticipant) {
      //   return (
      //     match.user == this.authUser._id ||
      //     this.hasRole('participant', match.homeTeamId) ||
      //     this.hasRole('participant', match.visitorTeamId) ||
      //     (match.judges && match.judges.includes(this.authUser._id))
      //   )
      // }

      return true
    },
    create() {
      this.clearOne()
      this.clearOneActs()
      this.action = 'create'
      this.edit = true
      this.nextTick(_ => {
        this.modal = true
      })
    },
    update({ matchId, actId }) {
      this.loadingMatch = matchId
      this.getOne(matchId)
        .then(_ => {
          this.action = 'update'
          this.edit = true
          this.nextTick(_ => {
            this.modal = true
          })
        })
        .finally(_ => {
          this.loadingMatch = ''
        })
      this.setOneActByScore({ actId })
    },
    // remove({ matchId, actId }) {
    remove() {
      this.loadingMatch = this.match._id
      const matchTemp = {
        _id: this.match._id,
        active: false
      }
      this.setUpdateMatch(matchTemp)
        .then(() => {
          this.updateGroup(matchTemp, false)
          this.nextTick(_ => {
            this.dialog = false
          })
        })
        .finally(_ => {
          this.loadingMatch = ''
        })
    },
    view({ matchId, actId }) {
      this.loadingMatch = matchId
      this.getOne(matchId)
        .then(_ => {
          this.nextTick(_ => {
            this.viewModal = true
          })
        })
        .finally(_ => {
          this.loadingMatch = ''
        })
      this.setOneActByScore({ actId, matchId })
    },
    closeModal() {
      this.clearOne()
      this.clearOneActs()
      this.nextTick(_ => {
        this.modal = false
        this.viewModal = false
      })
    },
    setGroup(phase, group, match, action) {
      this.phase = phase
      this.group = group
      switch (action) {
        case 'update':
          this.update({ matchId: match._id, actId: match.actId })
          break
        case 'delete':
          this.match = match
          this.dialog = true
          // this.remove({ matchId: match._id, actId: match.actId });
          break
        default:
          this.create()
          break
      }
    },
    updateGroup(match, addMatch = true, group) {
      let groupTemp = { ...(group || this.group) }
      groupTemp = {
        _id: groupTemp._id,
        matches: groupTemp.matches.map(item => item._id)
      }
      if (addMatch) groupTemp.matches.push(match._id)
      else {
        const i = groupTemp.matches.indexOf(match._id)
        groupTemp.matches.splice(i, 1)
      }
      const params = {
        idTournament: this.tournament._id,
        idPhase: this.phase._id,
        group: groupTemp
      }
      this.setUpdateGroup(params)
    },
    getObjectResult(match, objectId, showResults) {
      if (!this.isFinalized(match)) return '0'
      if (!objectId) return '0'
      const result = this.results.find(result => result.matchId == match._id)
      if (!result) return '0'
      const score = result.scores.find(score => score.objectId == objectId)
      if (!score) return '0'
      return showResults ? score.points : score.winner
    },
    getRankingByTeams(ranking, teams) {
      let result = []
      teams.forEach(team => {
        let teamScore = {
          objectId: team.teamId,
          points: 0
        }
        team.userIds.forEach(userId => {
          let score = ranking.find(score => score.objectId == userId)
          if (score) teamScore.points += score.points
        })
        if (teamScore.points) result.push(teamScore)
      })
      return result
    },
    formatParticipant(participantId, type) {
      if (this.tournament.type == 'teams') {
        let team = this.tournament.teams.find(
          team => team.teamId == participantId
        )
        return team ? team.name : this.$tc(type)
      } else {
        let user = this.tournament.users.find(
          user => user.userId == participantId
        )
        return user ? user.name : this.$tc(type)
      }
    },
    createRandomMatches(tournamentId, phaseId) {
      this.loading = true
      this.phaseId = phaseId
      this.setRandomMatches({ tournamentId, phaseId }).finally(
        () => (this.loading = false)
      )
    },
    isFinalized(match) {
      if (
        !match ||
        !match.finalized /*|| !match.judgesFinalized || !match.judges*/
      )
        return false
      // const isFinalized = match.judges.every(judge =>
      //   match.judgesFinalized.some(
      //     item => item.finalized && item.judgeId == judge
      //   )
      // )
      // return isFinalized
      return true
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  max-width: none !important;
}

.success--text {
  color: green;
}

.error--text {
  color: red;
}
</style>
